import { PaymentType, DeliveryType, } from "@wayke-se/ecom";
import EcomStep from "./constants/ecom-step";
import shouldUseCreditAssessment from "./utils/credit-assessment/usage-resolver";
export const getInitialStep = (options) => {
    if (options.requiresDealerSelection()) {
        return EcomStep.DEALER_CHOOSER;
    }
    return options.allowsTradeIn()
        ? EcomStep.TRADE_IN_EXISTS_CHOOSER
        : EcomStep.PAYMENT_METHOD_CHOOSER;
};
export const getIdentificationStep = (useBankId, useCreditAssessment) => {
    if (useBankId) {
        if (useCreditAssessment) {
            return EcomStep.CREDIT_ASSESSMENT_INFORMATION;
        }
        return EcomStep.BANKID_AUTHENTICATION;
    }
    return EcomStep.CUSTOMER_INFORMATION_INITIAL;
};
const emptyList = [];
export const getPrimarySteps = (options, useBankId) => {
    const result = [];
    if (options.requiresDealerSelection()) {
        result.push(EcomStep.DEALER_CHOOSER);
    }
    if (options.allowsTradeIn()) {
        result.push(EcomStep.TRADE_IN_EXISTS_CHOOSER);
    }
    result.push(EcomStep.PAYMENT_METHOD_CHOOSER);
    result.push(getIdentificationStep(useBankId));
    if (options.getInsuranceOption()) {
        result.push(EcomStep.INSURANCE_INFORMATION_DEFINITION);
    }
    const accessories = options.getAccessories();
    if (accessories && accessories.length > 0) {
        result.push(EcomStep.ACCESSORIES_CHOOSER);
    }
    const deliveryOptions = options.getDeliveryOptions() || emptyList;
    if (deliveryOptions.length > 1 ||
        (deliveryOptions.length === 1 &&
            deliveryOptions[0].type !== DeliveryType.Pickup)) {
        result.push(EcomStep.DELIVERY_METHOD);
    }
    result.push(EcomStep.FINAL_SUMMARY);
    result.push(EcomStep.FINAL_CONFIRMATION);
    return result;
};
const displayDeliveryOptions = (options) => {
    const deliveryOptions = options.getDeliveryOptions() || emptyList;
    return !(deliveryOptions.length === 1 &&
        deliveryOptions[0].type === DeliveryType.Pickup);
};
const displayAccessories = (options) => {
    const accessories = options.getAccessories();
    return accessories && accessories.length > 0;
};
export const getAllTransitions = () => ({
    [EcomStep.DEALER_CHOOSER]: (_, options) => {
        return options.allowsTradeIn()
            ? EcomStep.TRADE_IN_EXISTS_CHOOSER
            : EcomStep.PAYMENT_METHOD_CHOOSER;
    },
    [EcomStep.TRADE_IN_EXISTS_CHOOSER]: (data) => {
        if (data.tradeInCar.wantsToDefineTradeIn) {
            return EcomStep.TRADE_IN_CAR_DEFINITION;
        }
        return EcomStep.PAYMENT_METHOD_CHOOSER;
    },
    [EcomStep.TRADE_IN_CAR_DEFINITION]: (data) => {
        if (data.tradeInCar.hasProvidedTradeInInfo) {
            return EcomStep.TRADE_IN_CAR_CONDITION;
        }
        return EcomStep.PAYMENT_METHOD_CHOOSER;
    },
    [EcomStep.TRADE_IN_CAR_CONDITION]: (data) => {
        if (data.tradeInCar.hasProvidedTradeInCondition) {
            return EcomStep.TRADE_IN_CONFIRM_CAR;
        }
        return EcomStep.PAYMENT_METHOD_CHOOSER;
    },
    [EcomStep.TRADE_IN_CONFIRM_CAR]: () => EcomStep.PAYMENT_METHOD_CHOOSER,
    [EcomStep.PAYMENT_METHOD_CHOOSER]: (data, options) => {
        const isLoan = data.payment.paymentType === PaymentType.Loan;
        if (isLoan) {
            return EcomStep.PAYMENT_FINANCING_DETAILS;
        }
        const useCreditAssessment = shouldUseCreditAssessment(data, options);
        return getIdentificationStep(data.useBankId, useCreditAssessment);
    },
    [EcomStep.PAYMENT_FINANCING_DETAILS]: (data, options) => {
        const useCreditAssessment = shouldUseCreditAssessment(data, options);
        return getIdentificationStep(data.useBankId, useCreditAssessment);
    },
    [EcomStep.CREDIT_ASSESSMENT_INFORMATION]: () => EcomStep.CREDIT_ASSESSMENT_SIGNING,
    [EcomStep.CREDIT_ASSESSMENT_SIGNING]: () => EcomStep.CREDIT_ASSESSED,
    [EcomStep.CREDIT_ASSESSED]: () => EcomStep.CUSTOMER_INFORMATION_DETAILS,
    [EcomStep.BANKID_AUTHENTICATION]: () => EcomStep.CUSTOMER_INFORMATION_DETAILS,
    [EcomStep.CUSTOMER_INFORMATION_INITIAL]: () => EcomStep.CUSTOMER_INFORMATION_DETAILS,
    [EcomStep.CUSTOMER_INFORMATION_DETAILS]: (data, options) => {
        if (options.getInsuranceOption()) {
            return EcomStep.INSURANCE_INFORMATION_DEFINITION;
        }
        if (displayAccessories(options)) {
            return EcomStep.ACCESSORIES_CHOOSER;
        }
        if (displayDeliveryOptions(options)) {
            return EcomStep.DELIVERY_METHOD;
        }
        return EcomStep.FINAL_SUMMARY;
    },
    [EcomStep.INSURANCE_INFORMATION_DEFINITION]: (data, options) => {
        if (data.insurance.wantsToSeeInsuranceOptions) {
            return EcomStep.INSURANCE_ALTERNATIVE_CHOOSER;
        }
        if (displayAccessories(options)) {
            return EcomStep.ACCESSORIES_CHOOSER;
        }
        if (displayDeliveryOptions(options)) {
            return EcomStep.DELIVERY_METHOD;
        }
        return EcomStep.FINAL_SUMMARY;
    },
    [EcomStep.INSURANCE_ALTERNATIVE_CHOOSER]: (data, options) => {
        if (displayAccessories(options)) {
            return EcomStep.ACCESSORIES_CHOOSER;
        }
        if (displayDeliveryOptions(options)) {
            return EcomStep.DELIVERY_METHOD;
        }
        return EcomStep.FINAL_SUMMARY;
    },
    [EcomStep.ACCESSORIES_CHOOSER]: (data, options) => {
        if (displayDeliveryOptions(options)) {
            return EcomStep.DELIVERY_METHOD;
        }
        return EcomStep.FINAL_SUMMARY;
    },
    [EcomStep.DELIVERY_METHOD]: () => EcomStep.FINAL_SUMMARY,
    [EcomStep.FINAL_SUMMARY]: () => EcomStep.FINAL_CONFIRMATION,
});
